// extracted by mini-css-extract-plugin
export default {"modalWrapper":"ModalOtp_modalWrapper__5z9kf","otpForm":"ModalOtp_otpForm__V+-W1","otpInput":"ModalOtp_otpInput__Kvse+"};